// @flow
// const {BASE_API} =window['runConfig']
// const {BILLING_URL} =window['runConfig']
// const {domain} =window['runConfig']
export const appConfig = Object.freeze({
  APP_NAME: 'iCare App',
  VERSION:'5.1.9',
  // dev mode to mock async data for instance
  DEV_MODE: true,
  // When you need some kind "console spam" to debug
  DEBUG_ENABLED: true,
  // fake delay to mock async
  FAKE_ASYNC_DELAY: 1000,
  BASE_API: "https://icareapi.astragraphia.co.id",
  BILLING_URL: "https://ebillingportal.documentsolution.com/#/invoice-customer",
  iSupport_URL: "https://isupport.ilog.co.id",
  DOMAIN: "documentsolution.com",
  CONNECTION_STATUS: {
    online: 'online',
    disconnected: 'disconnected',
  },

  // #region API configs
  earningGraph: {
    data: {
      API: 'api/earnigGraphData',
    },
  },
  teamMates: {
    data: {
      API: 'api/teamMates',
    },
  },
  userInfos: {
    data: {
      API: 'api/userInfos',
    },
  },
  // #endregion

  HELLO_WORD: 'Hello',
});
